import { render } from "./admin-tag-list.vue?vue&type=template&id=a24e53e6"
import script from "./admin-tag-list.vue?vue&type=script&lang=js"
export * from "./admin-tag-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__